import { getPricing } from "@/lib/pricing";

const PIXEL_ID = process.env.REACT_APP_FB_PIXEL_ID;
const CONSENT_KEY = "limonata-consent";

export const getConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
};

export const setConsent = (value) => {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    /* storage unavailable */
  }
};

let initialized = false;

export const initPixel = () => {
  if (typeof window === "undefined") return;
  if (window.__initPosthog) window.__initPosthog();
  if (initialized || !PIXEL_ID) return;
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
  window.fbq("track", "ViewContent", { content_name: "Unverschämt Erfolgreich Salespage" });
  initialized = true;
};

export const trackInitiateCheckout = () => {
  if (window.fbq && getConsent() === "granted") {
    window.fbq("track", "InitiateCheckout", { value: getPricing().price, currency: "EUR" });
  }
};
